<template>
	<div class="topic_stat">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">先进个人统计</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="stat_wrap" v-if="!isShowTableStat">
											<div class="stat_item">
												<div class="item_title">
													<div class="title_left">
														<div class="box"></div>
														<div class="title_text">按数量统计</div>
													</div>
													<div class="title_right" @click="showTableStat(0)">详细统计</div>
												</div>
												<ul class="data_list">
													<li class="data_item" v-for="(item, index) in topicTypeData" :key="index">
														<div class="data_text">{{ item.reaserchFieName }}</div>
														<div class="data_num">{{ item.totalNumber }}个</div>
													</li>
												</ul>
												<div class="item_echart" id="line"></div>
											</div>
											<div class="stat_item">
												<div class="item_title">
													<div class="title_left">
														<div class="box"></div>
														<div class="title_text">按学段统计</div>
													</div>
													<div class="title_right" @click="showTableStat(1)">详细统计</div>
												</div>
												<ul class="data_list">
													<li class="data_item" v-for="(item, index) in topicDomainData" :key="index">
														<div class="data_text">{{ item.researchFieName }}</div>
														<div class="data_num">{{ item.totalNumber }}个</div>
													</li>
												</ul>
												<div class="item_echart" style="height: 380px;"><TopicDomainStat title="所属学段" :data="topicDomainData" /></div>
											</div>
										</div>

										<TableStat @goBack="showChartStat" :showIndex="tableStatShowIndex" v-else />
									</div>

									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import TopicDomainStat from '@/views/backstage/topicManage/topicStat/components/charts/TopicDomainStat.vue';
import { apiEduReviewStick1, apiEduReviewStick2 } from '@/api/after/newInterface.js';
export default {
	data() {
		return {
			isShowTableStat: false, //是否显示表格统计
			tableStatShowIndex: 0, //显示表格统计的第几个
			topicTypeData: [], //课题类别数据
			topicDomainData: [], //课题领域数据
			topicStudyPhaseData: [], //课题学段数据
			topicResearchPhaseData: [], //课题研究领域数据
			disciplineData: [], //学科数据
			schoolData: [] //学校数据
		};
	},
	components: {
		Breadcrumb,
		TopicDomainStat
	},
	created() {
		this.topicTypeStat();
		this.$nextTick(() => {
			this.drawLine();
		});
	},
	methods: {
		// 课题类别统计
		async topicTypeStat() {
			const res = await apiEduReviewStick2(1);
			if (res.code == 200) {
				if (res.data.length > 0) {
					let arr = res.data.map(item => {
						return {
							researchFieName: item.unit,
							totalNumber: item.num1
						};
					});
					this.topicDomainData = arr;
				}
			} else {
				this.$message.error(res.data);
			}
		},
		drawLine() {
			let echarts = this.$echarts.init(document.getElementById('line'));
			let option;
			apiEduReviewStick1(1).then(res => {
				if (res.code == 200) {
					option = {
						xAxis: {
							type: 'category',
							data: res.data.list,
							axisTick: {
								alignWithLabel: true //类目轴中在 boundaryGap 为 true 的时候有效，可以保证刻度线和标签对齐
							}
						},
						yAxis: {
							type: 'value',
							axisLine: {
								show: false
							}
						},
						series: [
							{
								data: res.data.num,
								type: 'line'
							}
						]
					};
					echarts.setOption(option);
				} else {
					this.$message.error(res.msg);
				}
			});
		},

		// 显示表格统计
		showTableStat(index) {
			this.tableStatShowIndex = index;
			this.isShowTableStat = true;
		},
		// 显示图表统计
		showChartStat() {
			this.isShowTableStat = false;
		}
	}
};
</script>

<style scoped lang="scss">
.stat_wrap {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	.stat_item {
		padding: 10px;
		width: 45%;
		height: 500px;
		margin-bottom: 20px;
		border: 1px solid #f7f7f7;
		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
		.item_title {
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 2px solid #98b8d1;
			font-weight: bold;
			.title_left {
				display: flex;
				align-items: center;
				.box {
					height: 14px;
					width: 4px;
					background-color: #065b9b;
					margin-right: 5px;
				}
				.title_text {
				}
			}
			.title_right {
				cursor: pointer;
			}
		}

		.data_list1 {
			display: flex;
			flex-wrap: wrap;
			margin-top: 5px;
			.data_item1 {
				width: 20%;
				border: 1px solid #e2e2e2;
				margin-bottom: 5px;
				.data_text1 {
					border-bottom: 1px solid #e2e2e2;
					text-align: center;
				}
				.data_num1 {
					text-align: center;
				}
			}
		}

		.data_list {
			.data_item {
				display: flex;
				align-items: center;
				justify-content: space-between;
				height: 30px;
				border-bottom: 1px solid #e2e2e2;
				.data_text {
				}
				.data_num {
				}
			}
		}
		.item_echart {
			width: 100%;
			height: 430px;
		}
	}
}
</style>
